import classNames from "classnames";

// Constants
import { CATEGORIES_ENUMS } from "constants/navigation/categories";

// Helpers
import { isUrlActive } from "helpers/is";

// Hooks
import useTranslate from "hooks/useTranslate";

// Types
import { NewCategoryType } from "redux/game/slice";

import "./styles.sass";
import { FC } from "react";
import BangerGames from "assets/icons/banger/banger_games.webp";
import GloryGames from "assets/icons/glory/glory_games.webp";

type CategoryMobileItemProps = {
  item: NewCategoryType;
  onSelect: (category: CATEGORIES_ENUMS | string) => void;
  currentCategory: CATEGORIES_ENUMS | null | string;
};
const { VITE_APP_PROJECT_NAME } = import.meta.env;

const CategoryMobileItem: FC<CategoryMobileItemProps> = ({
  item,
  onSelect,
  currentCategory,
}) => {
  const t = useTranslate();

  const isBanger = VITE_APP_PROJECT_NAME === "banger";
  const ContainerClass = classNames("CategoryMobileItem__content_name", {
    // eslint-disable-next-line camelcase
    CategoryMobileItem__content_name_banger: isBanger,
  });
  const currentIcon = isBanger ? BangerGames : GloryGames;
  const handleClick = () => {
    onSelect(item.name);
  };
  const urlActive = isUrlActive(item.name);
  const CategoryMobileItemClass = classNames("CategoryMobileItem", {
    active: currentCategory === item.name || (urlActive && !currentCategory),
  });
  return (
    // eslint-disable-next-line react/button-has-type
    <button onClick={handleClick} className={CategoryMobileItemClass}>
      <div className="CategoryMobileItem__content">
        <div className="CategoryMobileItem__content_icon">
          <img src={item.pathToImg || currentIcon} alt="icon" />
        </div>
        <div className={ContainerClass}>{t(item.translatePlaceholder)}</div>
      </div>
    </button>
  );
};

export default CategoryMobileItem;
